import { render } from "./NavMenu.vue?vue&type=template&id=5bad4b70"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=5bad4b70&scope=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\OMS\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__